import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { SFE_STEP_INFO } from './constant/SFE-step-info';
import { ExcelService } from './excel.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // 确认框
  confirmModal?: NzModalRef;
  // 所有step Info
  stepInfo = [...SFE_STEP_INFO];
  // 系统的一些配置项
  public configJson = JSON.parse($.ajax({
    url: '../assets/config/config.json',
    async: false,
  }).responseText);

  constructor(
    private lb4ApiService: Lb4ApiService,
    private modal: NzModalService,
    private message: NzMessageService,
    private route: Router,
    private translateService: TranslateService,
    private excelService: ExcelService,
  ) { }

  switchDateLanguage(date: string) {
    // 多国语言时间
    const lan = localStorage.getItem('language');
    if (!lan.includes('zh')) {
      moment.locale('en');
      date = String(moment(new Date(date)).format('lll'));
    }
    else {
      moment.locale(lan.toLowerCase().replace('_', '-'));
      date = String(moment(new Date(date)).format('YYYY-MM-DD HH:mm:SS'));
    }
    return date;
  }

  // 获取单据的最大版本
  async getMaxVersion(formid: string) {
    let maxVersion = await this.lb4ApiService.find('form_head',
      {
        order: 'version DESC',
        where: { "formId": formid }, fields: { version: true }
      }
    );
    return maxVersion[0]['version'];
  }
  // 进入单据详情
  async reportAndKanbanDetailData(formId: string, url: object, objData?: object) {
    let [signStepEmplid, urlName, step, status, projectCategory, activeBtn,] = ["", "", 0, 0, null, ""];
    const maxVersion = await this.getMaxVersion(formId);
    const signData = await this.lb4ApiService.find('form_sign_process', {
      order: "id DESC",
      where: { "formId": formId, "version": maxVersion },
    });
    // 显示最后一个status=1的step单据详情,如果没有status=1的则根据step0的状态来显示
    const status1Arr = signData.filter(obj => obj['status'] === 1);
    if (status1Arr.length > 0) {
      status = Number(status1Arr[0]['signStep']) >= 11 ? 0 : 1;
      if (Number(status1Arr[0]['signStep']) === 5 && objData) {
        step = status1Arr[0]['civilOrElectro'] === objData['civilOrElectro'] ? Number(status1Arr[0]['signStep']) : Number(status1Arr[1]['signStep']);
        signStepEmplid = status1Arr[0]['civilOrElectro'] === objData['civilOrElectro'] ? status1Arr[0]['emplid'] : status1Arr[1]['emplid'];
        localStorage.setItem('vendorCode', signStepEmplid);
      }
      else {
        step = Number(status1Arr[0]['signStep']);
        signStepEmplid = status1Arr[0]['emplid'];
        // 如果已有专案分类
        if ([9, 10].includes(status1Arr[0]['signStep']) && objData) {
          projectCategory = objData['projectCategory'];
          status = (status1Arr[0]['signStep'] === 9 && projectCategory === 1) || (status1Arr[0]['signStep'] === 10 && projectCategory === 0) ? 0 : 1;
        }
      }
    }
    //申请单位-项目管理审核中||已驳回||已取消
    else {
      // 申请人单据状态
      const applicantIndex = signData.length - 1;
      // 根据step0的状态显示单据详情
      signStepEmplid = signData[applicantIndex]['emplid'];
      step = Number(signData[applicantIndex]['signStep']);
      status = Number(signData[applicantIndex]['status']);
    }
    this.stepInfo[step].forEach(obj => {
      if (projectCategory !== null) {
        if (obj.stauts === status && obj['projectCategory'] === projectCategory) {
          activeBtn = obj.activeBtn;
          urlName = obj.name;
        }
      }
      else {
        if (obj.stauts === status) {
          activeBtn = obj.activeBtn;
          urlName = obj.name;
        }
      }
    });
    await this.detailData(formId, url, activeBtn, step, signStepEmplid, urlName);
  }

  // 进入单据详情
  async detailData(formId: string, url: object, activeBtn: string, step: number, signStepEmplid: string, urlName: string) {
    let formHead = await this.lb4ApiService.find('form_head', { where: { formId: formId } });
    if (formHead[0]['editor'] === signStepEmplid || formHead[0]['isEdit'] !== 1) {
      this.route.navigate([`/${url['value']}/detailapplication/detailitem`],
        {
          queryParams: {
            name: urlName,
            url: url['value'],
            formid: formId,
            activeBtn: activeBtn,
            step: step,
            signStepEmplid: signStepEmplid
          }
        });
    } else {
      this.modal.confirm({
        nzContent: '此单据正在被"变更需求"或者"任务指派"，无法编辑，请等待',
        nzOnOk: () =>
          new Promise((resolve, reject) => {
            const crypto = window.crypto.getRandomValues(new Uint8Array(1))[0] * 0.001;//符合密码学要求的安全的随机值
            setTimeout(crypto > 0.5 ? resolve : reject, 1);
          })
      });
    }
  }

  // 导出为Excel
  exportToExcel(excelName: string, tableOption: Array<object>, listOfData: Array<object>, merge?: Array<number>) {
    this.confirmModal = this.modal.confirm({
      nzTitle: this.translateService.instant('Common.ExportToExcelTitle'),
      nzContent: this.translateService.instant('Common.ExportToExcelContent'),
      nzOnOk: () =>
        new Promise((resolve, reject) => {
          const crypto = window.crypto.getRandomValues(new Uint8Array(1))[0] * 0.001;//符合密码学要求的安全的随机值
          setTimeout(crypto > 0.5 ? resolve : reject, 1);
          this.excelService.exportToExcel(excelName, tableOption, listOfData, merge);
        }).catch((e) => {
          if (!!e) this.message.create('error', `${this.translateService.instant('Common.ExportFailed')}`);
        })
    });
  }

  async getHolidayAndWeekend() {
    // 获取holiday(2)和周末(1)
    let holidayAndWeekend = [];
    // 周末
    await this.lb4ApiService.find('base_holiday',
      {
        "where": { "cdproperty": 1 },
        "fields": { "cdate": true }
      }).then(res => {
        res.forEach(obj => {
          holidayAndWeekend.push((moment(obj['cdate']).format('YYYY-MM-DD')));
        });
      });
    // 节假日
    await this.lb4ApiService.find('base_holiday',
      {
        "where": { "cdproperty": 2 },
        "fields": { "cdate": true }
      }).then(holidayRes => {
        holidayRes.forEach(holidayObj => {
          holidayAndWeekend.push(moment(holidayObj['cdate']).format('YYYY-MM-DD'));
        });
      });
    return holidayAndWeekend;
  }
  // 获取逾期天数
  getDelayedDays(targetDay: number, obj: object, holidayAndWeekend: Array<string>) {
    // 只对比nowDate和maxSignDate年月日,不对比时分秒==>后变更为对比nowDate和maxSignDate年月日时分秒
    const timeArr = ['applayTime', 'ieBaTime', 'applyMinistryTime', 'classLevelTime', 'assignVendorTime', 'bidDrawTime', 'engineerCheckTime', 'classCheckTime', 'ministerialCheckTime', 'budgetCheckTime', 'enquiryTime', 'prStartTime', 'prEndTime', 'poEndTime'];
    let signedArr = [];
    let signDateArr = [];
    const nowDate = moment().format('YYYY-MM-DD HH:mm:ss');
    // 签核时间数组
    timeArr.forEach(ele => {
      if (!!obj[ele]) {
        signedArr.push(ele);
        signDateArr.push(new Date(obj[ele]));
      }
    });
    // 获取所有签核日期的最大值
    const maxSignDate = moment(Math.max.apply(null, signDateArr)).format('YYYY-MM-DD HH:mm:ss');
    // 系统当前日期与计划完成日期之间的间隔天数(排除周末和节假日)
    const diffWeekDays = this.getWeekdaysDiffDays(maxSignDate, nowDate, holidayAndWeekend);
    // 如果是询价之后无逾期天数
    return diffWeekDays - targetDay <= 0
      || (obj['signStep'] === 10 && obj['projectCategory'] === 0)
      || (obj['signStep'] === 9 && obj['projectCategory'] === 1)
      || (obj['signStep'] >= 11)
      ? '/' : (diffWeekDays - targetDay);
  }
  // 预计厂商提供标单时间:根据开始日期和间隔天数得到结束日期(排除周末)
  getWeekdaysEndDateTime(startDateTime: string, intervalDays: number) {
    let endDateTime: string;
    // 根据获取或设置星期几。星期日为 0、星期六为 6
    let startDateWeekDay = moment(startDateTime).day();
    for (let i = 1; i <= intervalDays; i++) {//遍历intervalDays次,每次在开始日期上累加1天
      if (startDateWeekDay === 6 || startDateWeekDay === 0) {//如果startDateWeekDay是周末
        startDateTime = moment(startDateTime).add(1, 'days').format("YYYY-MM-DD HH:mm");
        startDateWeekDay = moment(startDateTime).day();
        intervalDays += 1;
      }
      else {
        endDateTime = moment(startDateTime).add(1, 'days').format("YYYY-MM-DD HH:mm");
        startDateTime = endDateTime;
        let endDateWeekDay = moment(endDateTime).day();
        if (endDateWeekDay === 6 || endDateWeekDay === 0) {//如果endDateWeekDay是周末
          intervalDays += 1;
        }
      }
    }
    return endDateTime;
  }
  // 根据开始日期和结束日期得到间隔天数(排除周末和节假日)
  getWeekdaysDiffDays(startDateTime: string, endDateTime: string, holidayAndWeekend: Array<string>) {
    let diffWeekDays = 0;
    //相差天数(包含周末和节假日)
    const diffDays = moment(endDateTime).diff(moment(startDateTime), 'day');
    for (let i = 1; i <= diffDays; i++) {//遍历diffDays次,每次在开始日期上累加1天
      // startDateTime = moment(startDateTime).add(1, 'days').format("YYYY-MM-DD HH:mm:ss");
      let startDate = moment(startDateTime).add(1, 'days').format("YYYY-MM-DD");
      if (!holidayAndWeekend.includes(startDate)) {
        diffWeekDays += 1;
      }
    }
    return diffWeekDays;
  }

  // 日期选择范围
  disabledDate = (current: Date, type: "week" | "day"): boolean => {
    let isSelect: boolean;
    if (type === "day" && moment().diff(current) >= 0 && moment(current).year() > 2021) {
      isSelect = false;
    }
    else {
      isSelect = true;
    }
    return isSelect;
  }
}
